var map = {
	"./support_1.png": "Q82C",
	"./support_2.png": "Jerv",
	"./support_3.png": "YK0r",
	"./support_4.png": "4Z8c",
	"./support_5.png": "2A8F",
	"./support_6.png": "A+6D",
	"./support_7.png": "Wtwo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Qy/S";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates ^\.\/support_.*\.png$
// module id = Qy/S
// module chunks = 0